import { Icon } from "@legal-500/legal500-design-system";
import styles from "./UnauthorizedView.module.css";

type UnauthorizedViewProps = {
  message?: string;
};

export function UnauthorizedView({ message }: UnauthorizedViewProps) {
  return (
    <div className={styles.container}>
      <Icon icon="exclamation" size="xlarge" className={styles.icon} />
      <p className={styles.title}>Access Denied</p>
      <p className={styles.message}>
        {message ||
          "You don't have permission to view this data. Please contact your administrator to request access."}
      </p>
    </div>
  );
}
